import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required('A name is required.')
    .matches(
      /^[a-zA-Z\s]+$/,
      'A name must consist only of alphabet characters and spaces.'
    ),
  parentId: yup.number().required('A parent Insight Resolution is required.'),
});
